import { api, apiEndpoints } from './apiService';

export interface ReservationsIntegrationStatus {
  ok?: boolean;
  store_id?: number;
  current_reservation_partner?: string;
  has_active_connection?: boolean;
  reservations?: {
    has_active_connection?: boolean;
  };
}

export function reservationsStatusHasActiveConnection(
  data: ReservationsIntegrationStatus | null | undefined,
): boolean {
  if (!data || typeof data !== 'object') return false;
  if (data.reservations?.has_active_connection === true) return true;
  if (data.has_active_connection === true) return true;
  return false;
}

export async function fetchReservationsIntegrationStatus(): Promise<ReservationsIntegrationStatus | null> {
  const response = await api.get(
    apiEndpoints.getReservationsIntegrationStatus(),
  );
  if (!response?.ok) return null;
  return (await response.json()) as ReservationsIntegrationStatus | null;
}
